import React, { useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import Patients from './pages/Patients/Patients';
import Providers from './pages/Providers/Providers';
import Veterans from './pages/Veterans/Veterans';

import history from './lib/history';
import RainbowBar from './shared/RainbowBar/RainbowBar';
import HeaderNav from './shared/HeaderNav/HeaderNav';
import Footer from './shared/Footer/Footer';
import LinkModal from './shared/LinkModal/LinkModal';
import VisitButton from './shared/VisitButton/VisitButton';

import './App.scss';

const App = () => {
  const initialPosition = document.location.pathname === '/' ? 'home' : document.location.pathname.slice(1);
  const [position, setPosition] = useState(initialPosition);
  const [isModalOn, setIsModalOn] = useState(false);

  return (
    <BrowserRouter history={history} >
      <RainbowBar />
      <HeaderNav position={position} setPosition={setPosition} />

      <Routes>
        <Route
          exact
          path="/"
          element={
            <Home>
              <VisitButton clickHandler={() => setIsModalOn(true)} />
            </Home>
          }
        />

        <Route
          path="/patients"
          element={
            <Patients>
              <VisitButton clickHandler={() => setIsModalOn(true)} />
            </Patients>
          }
        />

        <Route
          path="/providers"
          element={
            <Providers>
              <VisitButton clickHandler={() => setIsModalOn(true)} />
            </Providers>
          }
        />

        <Route path="/about" element={<About />} />

        <Route path="/veterans" element={<Veterans />} />
      </Routes>

      {
        isModalOn && (
          <LinkModal
            isModalOn={isModalOn}
            modalClickHandler={() => setIsModalOn(false)}
          />
        )
      }
      <Footer />
    </BrowserRouter>
  );
};

export default App;
